import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../../services/indentifyDevice";
import LoginIdForm, { ILoginIdFormProps } from "../forms/loginIdForm";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";

export interface ILoginIdScreenProps extends ILoginIdFormProps {
  onClose?: () => void;
}

const LoginIdScreen: React.FC<ILoginIdScreenProps> = (props) => {
  return (
    <LoginPopup
      leftHeaderContent={
        !DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      centerHeaderContent={
        DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      onClose={props.onClose}
      className="login_scrn"
    >
      <LoginIdForm {...props} />
    </LoginPopup>
  );
};

export default LoginIdScreen;
